export const CAPITAL_TYPE = {
  CASH: 1,   // سيولة
  ASSET: 2,  // أصول
};

export const CAPITAL_TYPE_OPTIONS = [
  { value: CAPITAL_TYPE.CASH, label: "سيولة" },
  { value: CAPITAL_TYPE.ASSET, label: "أصول" },
];

export const getCapitalTypeLabel = (type) =>
  CAPITAL_TYPE_OPTIONS.find((opt) => opt.value === Number(type))?.label || "-";